/**
 * @file
 * LMI behaviors.
 */
(function (Drupal, $) {
  "use strict";

  $(document).ready(function() {
    sixty_forty();
    fifty_fifty();
    media_carousel();
    logo_slider();
    sec_sticky_nav();
    menu_paragraphs();
    tabs();
  });

  $(window).on('resize', function() {
    sixty_forty();
  });

  function sixty_forty() {
    $('.sixty-forty-sec').each(function() {
      var $this = $(this);

      if ($this.hasClass('uncropped') ) {
        if ( $(this).find('.helper').css('display') == 'block') {
          $this.css('height', $this.find('img').height() );
        }
        else {
          $this.css('height', 'auto');
        }
      }
    });
  };

  function fifty_fifty() {
    $(".fifty-fifty-sec .fifty-video ").on("click", function () {
      $(this).removeClass("overlay");
      $(this).removeClass("thumbnail-media");
      $(this).find(".play-btn").addClass("d-none");

      if ($(this).find("video").length > 0) {
        if ($(this).find("video").get(0).paused) {
          $(this).find("video").trigger("play");
        } else {
          $(this).find("video").trigger("pause");
        }
      } else if ($(this).find(".iframe-wrapper").length > 0) {
        let element_keys = $(this).find(".play-btn").data("id");
        let element_src = $(this).find(".play-btn").data("src");
        var $iframe = $("#" + element_keys);
        if ($iframe.length) {
          $($iframe).append(
            '<iframe width="100%" height="100%" src="' +
            element_src +
            '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
          );
          return false;
        }
      }
    });
  }

  function media_carousel() {
    $(".media-carousel-list").each(function () {
      if ($(this).find("li").length >= 2) {
        $(this).slick({
          dots: true,
          arrows: true,
          infinite: true,
          speed: 500,
          variableWidth: true,
          useTransform: false,
          centerMode: false,
          centerMode: true,
          responsive: [
            {
              breakpoint: 1099,
              settings: {
                variableWidth: false,
              },
            },
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                centerMode: false,
                centerPadding: "0px",
              },
            },
          ],
        });

        $($(this)).on("afterChange", function () {
          $(".carousel-list-overlay").removeClass("carousel-list-overlay");
          fade_reset();
        });

        $(this).on(
          "beforeChange",
          function (event, { slideCount: count }, currentSlide, nextSlide) {
            let selectors = [nextSlide, nextSlide - count, nextSlide + count]
              .map((n) => `[data-slick-index="${n}"]`)
              .join(", ");
            $(".slick-now").removeClass("slick-now");
            $(selectors).addClass("slick-now");
          }
        );

        $('[data-slick-index="0"]').addClass("slick-now");

        function fade_reset() {
          let total_width = 1440;
          $(".media-carousel-list .slick-slide").each(function (index) {
            if ($(this).hasClass("slick-current")) {
              let this_slide_index = $(this).data("slick-index");
              let this_slide = $(this).width() + 32;
              let next_slide1 = $(this).next().width() + 32;
              let next_slide2 = $(this).next().next().width() + 32;
              let next_slide3 = $(this).next().next().next().width() + 32;

              if (
                this_slide + next_slide1 + next_slide2 + next_slide3 <
                total_width
              ) {
                $("[data-slick-index='" + (this_slide_index + 3) + "']")
                  .nextUntil()
                  .addClass("carousel-list-overlay");
              } else if (this_slide + next_slide1 + next_slide2 < total_width) {
                $("[data-slick-index='" + (this_slide_index + 2) + "']")
                  .nextUntil()
                  .addClass("carousel-list-overlay");
              } else if (this_slide + next_slide1 < total_width) {
                $("[data-slick-index='" + (this_slide_index + 1) + "']")
                  .nextUntil()
                  .addClass("carousel-list-overlay");
              } else {
                $(this).nextUntil().addClass("carousel-list-overlay");
              }
            }
          });
        }
        fade_reset();
      }
    });
  }

  function logo_slider() {
    $(".logo-slider").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 721,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "22%",
          },
        },
        {
          breakpoint: 464,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20%",
          },
        },
      ],
    });
  }

  function sec_sticky_nav() {
    if ( $('.paragraph--type--secondary-sticky-nav').length ) {
      $('.paragraph--type--secondary-sticky-nav a').each(function() {
        if ( $(location).attr('pathname') === $(this).attr('href') )  {
          $(this).addClass('active-trail');
        }
      });
    }
  }

  function menu_paragraphs() {
    if ($('.paragraph--type--automated-secondary-menu .component-label').length) {
      $('.paragraph--type--automated-secondary-menu .component-label').each(function () {
        $(this).find('.component-link').on("click", function (e) {
          $(this)
            .toggleClass("open")
            .next("div")
            .toggleClass("dropdown-block-open");
        });
      });

      $(".paragraph--type--automated-secondary-menu .field__item > .menu > .menu-item > a").on("focus", function () {
        $(this).parent().addClass("hovercls");
        $(".paragraph--type--automated-secondary-menu .field__item > .menu > .menu-item > a")
          .not($(this))
          .parent()
          .removeClass("hovercls");
        return false;
      });

      $(".paragraph--type--automated-secondary-menu .field__item > .menu > .menu-item").mouseover(function(e) {
        var $menucontainers = $(".paragraph--type--automated-secondary-menu .field__item > .menu > .menu-item > a");
        $menucontainers.each(function() {
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0) {
            $(this).parent().removeClass("hovercls");
          }
        });
      });

      $(".paragraph--type--automated-secondary-menu .add-dropdown").removeClass('add-dropdown');

    }
  }

  function tabs() {
    $(".nav-pills .nav-item button").each(function () {
      if ( $(this).parent().is(':first-child') ) {
        setTimeout(() => {
          $(this).attr('aria-selected', true);  
          $(this).parent().attr('aria-selected', true);  
        }, 5000);
      }

      $(this).on("click", function () {
        $(this).parents('.nav-pills').find('[aria-selected="true"]').attr('aria-selected', false);
        $(this).parent().attr('aria-selected', true);
        $(this).attr('aria-selected', true);  

        if ( $(this).parents('.nav-pills').attr('aria-orientation') == 'vertical' ) {
          $(this)
          .parents(".tab-section")
          .find(".vertical-tab-trigger")
          .text($(this).text())
          .click();
        }
        else {
          $(this)
          .parents(".tab-section")
          .find(".tab-trigger")
          .text($(this).text())
          .click();
        }
      });
    });
  }

  Drupal.behaviors.lmi = {
    attach: function (context, settings) {

      $(".change-bg-img", context).click(function () {
        $("#" + $(this).data("tab-bg-img-target"))
          .attr("src",$(this).data("tab-bg-img-src"))
          .attr("class",$(this).data("tab-bg-img-align"));
      });

      $(".change-bg-class", context).click(function () {
        if ($(this).data("tab-bg-class") == "") {
          $("#" + $(this).data("tab-bg-class-target")).removeClass("dark-bg");
        }
        $("#" + $(this).data("tab-bg-class-target")).addClass(
          $(this).data("tab-bg-class")
        );
      });
      let mybutton = document.getElementById("btn-back-to-top");
      // When the user scrolls down 20px from the top of the document, show the button
      if (mybutton) {
        window.onscroll = function () {
          scrollFunction();
        };
        mybutton.addEventListener("click", backToTop);
      }
      function scrollFunction() {
        if (
          document.body.scrollTop > 600 ||
          document.documentElement.scrollTop > 600
        ) {
          mybutton.style.display = "block";
        } else {
          mybutton.style.display = "none";
        }
      }

      // Single Video Component - Play on Overlay Btn Click

      $(".single-video-desc .video-play").on("click", function () {
        if (
          $(this).closest(".single-video-box").find(".iframe-wrapper").length > 0
        ) {

          let element_src = $(this).data("src");
          var $iframe = $(this).closest(".single-video-box").find("iframe");

          if ($iframe.length) {
            $iframe.attr("src", element_src + "?autoplay=1");
          }
        }
      });



      // When the user clicks on the button, scroll to the top of the document

      function backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }

      $(".contact-hidden-email").on("click", function () {
        $("input[type=hidden][name=hidden_email]").val($(this).data("email"));
        $(".bio-title").text($(this).data("name"));
        $(".bio-position").text($(this).data("position"));
      });

      $(".sort_order").on("change", function () {
        let cls_name = $(this).data("view-id");

        $("." + cls_name + " .view-filters form")
          .find("[name='sort_order']")
          .val($(this).val())
          .change();
      });

      $(".breadcrumb ol li").each(function () {
        $(this).html($(this).html().replace("&amp;", "&"));
      });

      once('header-search', 'header .search-block-form', context).forEach((element) => {
        const $block = $(element);

        if ($block.hasClass('views-exposed-form')) {
          const $input = $block.find('.form-text');

          if ($input.length && !$block.hasClass('lmi-processed')) {
            $input.attr('type', 'search');
            $block.find('.form-submit').after('<i class="icon-search"></i>');
            $block.addClass('lmi-processed');
          }
        }
      });
    },
  };

  Drupal.behaviors.trademark = {
    attach: function (context, settings) {
      function getDeepestTextChildren(element) {
        var deepest = [];

        function traverse(el) {
          var children = $(el).children();

          if (children.length === 0 && $(el).text().trim() !== "") {
            deepest.push(el);
          } else {
            children.each(function() {
              traverse(this);
            });
          }
        }

        traverse(element);
        return deepest;
      }

      // Example usage:
      var deepestElements = getDeepestTextChildren($(".region-content"));

      // Here we define an array of patterns we'd like to search for
      var parserRules = [
        { pattern: /®/g, replacement: '<span class="superscript">®</span>' }
      ];

      // Loop through the instances
      deepestElements.forEach(function(item) {
        if (item.innerText.indexOf('®') !== -1) {
          parserRules.forEach(function (rule) {
           item.innerHTML = item.innerText.replace(rule.pattern, rule.replacement);
          });
        }
      });
    },
  };
})(Drupal, jQuery);
